module.exports = __webpack_public_path__ + "img/goodsD3.34a22b55.png";